import { Injectable } from '@angular/core';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { ConfigService } from '../common/services/config.service';
import { Observable } from 'rxjs/internal/Observable';
@Injectable({
    providedIn: 'root'
})
export class BitlyService {
    constructor(
        private _httpInterceptor: HttpInterceptor) { }
    public validateBitly(replaceURL, consentData: any): Observable<any> {
        return this._httpInterceptor.Put(ConfigService.getInstance()
        .getConfigObject().APIURL.bitlyService.replace('{0}', replaceURL), consentData);
    }
}
